import classes from "./Services.module.css";
import { DiGhostSmall } from "react-icons/di";
import { BiPencil } from "react-icons/bi";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { BsArrowRight, BsArrowLeft, BsCode } from "react-icons/bs";
import { IconContext } from "react-icons";
import { useState } from "react";

const Services = () => {
  const iconsStyles = {
    color: "var(--first-color)",
    size: "2rem",
  };

  const checkMarkStyles = {
    width: "1rem",
    height: "1rem",
  };

  const [addDetailsClass1, setAddDetailsClass1] = useState(false);
  const [addDetailsClass2, setAddDetailsClass2] = useState(false);
  const [addDetailsClass3, setAddDetailsClass3] = useState(false);
  const detailsExpandHandler = (e: any) => {
    setAddDetailsClass1((prev) => !prev);
    setAddDetailsClass2(false);
    setAddDetailsClass3(false);
  };
  const detailsExpandHandler2 = (e: any) => {
    setAddDetailsClass2((prev) => !prev);
    setAddDetailsClass1(false);
    setAddDetailsClass3(false);
  };
  const detailsExpandHandler3 = (e: any) => {
    setAddDetailsClass3((prev) => !prev);
    setAddDetailsClass2(false);
    setAddDetailsClass1(false);
  };

  return (
    <IconContext.Provider value={iconsStyles}>
      <div className={classes.main_container}>
        <div className={classes.header}>
          {/* <h1>Services</h1> */}
          <h5>Lo que ofrezco!</h5>
        </div>
        <div className={classes.main_content}>
          <div
            className={`${classes.card_container} ${
              addDetailsClass1 ? classes.container_expand : ""
            }`}
          >
            <div className={classes.content_container}>
              <DiGhostSmall />
              <h1>Desarrollador Ui/Ux</h1>
              <div className={classes.view_more} onClick={detailsExpandHandler}>
                <span>View more</span>
                <BsArrowRight
                  style={{ width: "1rem", height: "1rem", color: "inherit" }}
                />
              </div>
            </div>
            <div className={classes.details_container}>
              <ul>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Diseño de interfaces de usuario.</span>
                </li>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Diseño centrado en el usuario.</span>
                </li>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Adaptabilidad de diseño.</span>
                </li>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Diseño de interacción.</span>
                </li>
              </ul>
              <div
                className={classes.left_arrow}
                onClick={detailsExpandHandler}
              >
                <BsArrowLeft
                  style={{
                    width: "2rem",
                    height: "2rem",
                    color: "var(--first-color)",
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className={`${classes.card_container} ${
              addDetailsClass2 ? classes.container_expand : ""
            }`}
          >
            <div className={classes.content_container}>
              <BsCode />
              <h1>Frontend Developer</h1>
              <div
                className={classes.view_more}
                onClick={detailsExpandHandler2}
              >
                <span>View more</span>
                <BsArrowRight
                  style={{ width: "1rem", height: "1rem", color: "inherit" }}
                />
              </div>
            </div>
            <div className={classes.details_container}>
              <ul>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Diseño responsive y mobile-first.</span>
                </li>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Animaciones y microinteracciones.</span>
                </li>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Manejo de las ultimas tendencias de diseño.</span>
                </li>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Diseño de componentes reutilizables.</span>
                </li>
              </ul>
              <div
                className={classes.left_arrow}
                onClick={detailsExpandHandler2}
              >
                <BsArrowLeft
                  style={{
                    width: "2rem",
                    height: "2rem",
                    color: "var(--first-color)",
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className={`${classes.card_container} ${
              addDetailsClass3 ? classes.container_expand : ""
            }`}
          >
            <div className={classes.content_container}>
              <BiPencil />
              <h1>Back End Developer</h1>
              <div
                className={classes.view_more}
                onClick={detailsExpandHandler3}
              >
                <span>View more</span>
                <BsArrowRight
                  style={{ width: "1rem", height: "1rem", color: "inherit" }}
                />
              </div>
            </div>
            <div className={classes.details_container}>
              <ul className={classes.ul_container}>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Gestión eficiente de bases de datos</span>
                </li>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Diseño de APIs seguras y escalables</span>
                </li>
                <li>
                  <AiOutlineCheckCircle style={checkMarkStyles} />
                  <span>Manejo de autenticación y autorización</span>
                </li>
              </ul>
              <div
                className={classes.left_arrow}
                onClick={detailsExpandHandler3}
              >
                <BsArrowLeft
                  style={{
                    width: "2rem",
                    height: "2rem",
                    color: "var(--first-color)",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </IconContext.Provider>
  );
};

export default Services;
